module.exports = __webpack_public_path__ + "img/file-outline.9e2b3678.svg";